module.exports = __webpack_public_path__ + "img/icon-filter.2ae5bf31.svg";